export default {"src":"/_next/static/media/use-case.287cdf2c.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};